import {useLazySourcingGetCarFeaturesQuery} from '@dms/api/core';

import {parseDate} from 'shared/web';

import {BaseVehicle} from '../../core/types/BaseVehicle';
import {getMakeValue} from '../../core/utils/getMakeValue';
import {getModelFamilyValue} from '../../core/utils/getModelFamilyValue';

/**
 * Fetches sourcing data for feature highlighting and premium detection
 */
export function useGetCarFeatures() {
  const [getSourcingFeatures, data] = useLazySourcingGetCarFeaturesQuery();

  const getCarFeatures = async (formData: BaseVehicle) => {
    const make = getMakeValue(formData);
    const model = getModelFamilyValue(formData);
    const year =
      (formData.firstRegistrationOn
        ? parseDate(formData.firstRegistrationOn)?.getFullYear()
        : undefined) ??
      (formData.manufacturedOnYear ? Number(formData.manufacturedOnYear) : undefined);

    if (!make || !model || !year) {
      return null;
    }

    try {
      const {data: sourcingFeatures} = await getSourcingFeatures({
        body: {
          make,
          model,
          year,
          features: formData.features || [],
        },
      });

      return sourcingFeatures;
    } catch (error) {
      console.warn('Failed to fetch sourcing features:', error);
      return null;
    }
  };

  return [getCarFeatures, data] as const;
}
